<template>
  <main class="relative pb-5 pt-3">
    <UiContainer tag="section" class="mb-7">
      <UiButton
        severity="tertiary"
        class="flex w-full items-center justify-between bg-primary !px-5 !py-4 text-left"
        @click="showLocationDialog = true"
      >
        <div>
          <p class="text-xs text-text-secondary">город</p>
          <p class="text-sm font-medium">{{ currentLocation?.displayName || 'Москва' }}</p>
        </div>
      </UiButton>
    </UiContainer>
    <UiContainer tag="section">
      <h1 class="mb-4 font-medium">Нужна помощь?</h1>
      <ul>
        <li v-for="link in FAQLinks" :key="link.title" class="mb-3 last:mb-0">
          <UiButton
            :tag="link.external ? 'a' : AppRouterLink"
            :to="link.to"
            :href="link.to"
            severity="tertiary"
            class="flex h-[70px] w-full items-center justify-between !px-5 !py-4 text-left"
          >
            <div class="relative">
              <p class="text-sm font-medium">
                {{ link.title }}
              </p>
              <p
                v-if="link.description"
                class="text-xs text-text-secondary"
                v-html="link.description"
              />
            </div>
          </UiButton>
        </li>
      </ul>
    </UiContainer>
    <UiDialog v-model="showLocationDialog">
      <template #default="{ height }">
        <ChooseLocation is-page :style="{ height }" @close="showLocationDialog = false" />
      </template>
    </UiDialog>
  </main>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { ref } from 'vue'
import { ChooseLocation } from '@/4_features/Location'
import { FAQLinks } from '@/5_entities/FAQ'
import { useLocation } from '@/5_entities/Location'
import { AppRouterLink, UiButton, UiContainer, UiDialog } from '@/6_shared/ui'

const showLocationDialog = ref(false)
const { currentLocation } = storeToRefs(useLocation())
</script>
